import Clipboard from 'clipboard'
import { Toast } from 'vant'
import { invokeCopy } from './native'
import { isHzwApp, isRkhy } from './cookie'

export async function clipboardText(text: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const fakeElement = document.createElement('button')
    const clipboard = new Clipboard(fakeElement, {
      text: function() {
        return text
      },
      action: function() {
        return 'copy'
      },
      container: document.body
    })
    clipboard.on('success', e => {
      clipboard.destroy()
      resolve('复制成功')
    })
    clipboard.on('error', e => {
      clipboard.destroy()
      reject('复制失败,请手动复制')
    })
    document.body.appendChild(fakeElement)
    fakeElement.click()
    document.body.removeChild(fakeElement)
  })
}

 class Copy {
  isLock = false;
  text(text:string){
    if(this.isLock) {
      return false
    }
    this.isLock = true
    if (isHzwApp() || isRkhy()) {
      invokeCopy({ value: text })
      this.isLock = false
    } else {
      clipboardText(text)
        .then((value: string) => {
          Toast(value);
          setTimeout(()=>{
            this.isLock = false
          },2000)
        })
        .catch((errorText: string) => {
          window.prompt('复制失败,请手动复制', errorText)
          this.isLock = false
        })
    }
  }
}
export const copy = new Copy()